import styled, { css } from "styled-components";
import BaseLayout from "../BaseLayout/BaseLayout";

export const MainLayoutRoot = styled(BaseLayout)(
    () => css`
        padding-top: var(--appbar-height);
    `,
);
